import React from 'react';
import { Hero } from '../components/Hero';
import { WhatIsIt } from '../components/WhatIsIt';
import { Tomos } from '../components/Tomos';
import { Bonuses } from '../components/Bonuses';
import { Testimonials } from '../components/Testimonials';
import { WhatYouReceive } from '../components/WhatYouReceive';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
export function Landing() {
  return <main className="min-h-screen bg-[#0a0517]" data-id="element-187">
      <Hero data-id="element-188" />
      <WhatIsIt data-id="element-189" />
      <Tomos data-id="element-190" />
      <Bonuses data-id="element-191" />
      <Testimonials data-id="element-192" />
      <WhatYouReceive data-id="element-193" />
      <FinalOffer data-id="element-194" />
      <Footer data-id="element-195" />
    </main>;
}